/**
 * Os traços "desenhados" do Caderno: visto, quadrado de checkbox, círculo de
 * caneta, risco. Todos seguem a mesma regra do handoff — `pathLength="100"`,
 * `stroke-dasharray: 100` e `stroke-dashoffset` de 100 a 0 pela folha —, e por
 * isso começam do zero, sem ponto inicial visível.
 *
 * São geometria de SVG: nenhum `style` no markup (CSP `style-src 'self'`).
 * Cor, espessura e tempo vêm de `caderno.css`.
 */

/** O visto à mão. `feito` liga o traço; sem ele o visto fica por desenhar. */
export function Visto({ feito = false, className }: { feito?: boolean; className?: string }) {
  return (
    <svg className={["visto", className ?? ""].filter(Boolean).join(" ")} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        className={feito ? "traco-desenhado traco-desenhado--feito" : "traco-desenhado"}
        pathLength={100}
        d="M4 13.2c1.9 1.5 3.4 3.1 4.8 5.3C11.6 12.9 15.3 8.4 20.5 4.6"
      />
    </svg>
  );
}

/**
 * O quadrado de checkbox desenhado à mão, com o visto por cima. É só a
 * aparência: quem é marcável continua sendo o `<input>` ou o botão ao redor.
 */
export function CaixaMao({
  marcada,
  verde = false,
  className,
}: {
  marcada: boolean;
  verde?: boolean;
  className?: string;
}) {
  const classes = ["caixa-mao", marcada ? "caixa-mao--marcada" : "", verde ? "caixa-mao--verde" : "", className ?? ""]
    .filter(Boolean)
    .join(" ");
  return (
    <span className={classes} aria-hidden="true">
      <svg viewBox="0 0 30 30" focusable="false">
        <path className="caixa-mao__quadro" d="M5.2 5.6c6.4-.5 13-.4 19.5-.1.3 6.4.4 12.9.1 19.3-6.5.3-13 .4-19.4.1-.4-6.4-.5-12.9-.2-19.3Z" />
        <path className="caixa-mao__visto" pathLength={100} d="M8.5 15.5c1.6 1.3 2.9 2.6 4.1 4.4 2.9-5.4 6.4-9.7 11.4-13.5" />
      </svg>
    </span>
  );
}

/** O círculo de caneta que se desenha em volta de uma palavra (9b, dias de descanso). */
export function CirculoMao({ feito, className }: { feito: boolean; className?: string }) {
  return (
    <svg className={["circulo-mao", className ?? ""].filter(Boolean).join(" ")} viewBox="0 0 60 36" preserveAspectRatio="none" aria-hidden="true" focusable="false">
      <path
        className={feito ? "traco-desenhado traco-desenhado--feito" : "traco-desenhado"}
        pathLength={100}
        d="M31 3.5C16 2.6 3.8 7.8 3.2 17.6c-.6 9.6 11.4 15.4 26.6 15 15.6-.4 27.2-6.6 27-15.6C56.6 8.7 44.8 3.3 28.5 4.6"
      />
    </svg>
  );
}
